import clsx from "clsx";
import { getThreadCategoryTag, type ThreadTag } from "@/entities/thread";
import { isR18ThreadTagName } from "@/shared/lib/threadTag";

interface TagBadgesProps {
  tags: ThreadTag[];
  className?: string;
  /** 横幅の限られた表示ではR18をカテゴリより先に配置する。 */
  r18First?: boolean;
  /** タグが0件でもレイアウト用のコンテナを描画する。 */
  shouldRenderWhenEmpty?: boolean;
}

export const TagBadges: React.FunctionComponent<TagBadgesProps> = ({
  tags,
  className,
  r18First = false,
  shouldRenderWhenEmpty = false,
}: TagBadgesProps) => {
  const categoryTag = getThreadCategoryTag(tags);
  const r18Tag = tags.find((tag) => isR18ThreadTagName(tag.name));
  const orderedTags = r18First ? [r18Tag, categoryTag] : [categoryTag, r18Tag];
  const visibleTags = orderedTags.filter(
    (tag): tag is ThreadTag => tag !== undefined,
  );

  if (visibleTags.length === 0 && !shouldRenderWhenEmpty) return null;

  return (
    <ul
      aria-label={visibleTags.length > 0 ? "タグ" : undefined}
      aria-hidden={visibleTags.length === 0 ? true : undefined}
      className={clsx("m-0 flex list-none flex-wrap gap-1 p-0", className)}
    >
      {visibleTags.map((tag) => (
        <li
          key={`${tag.source}:${tag.kind}:${tag.name}`}
          data-r18={isR18ThreadTagName(tag.name) || undefined}
          className={clsx(
            "rounded px-1.5 py-0.5 text-2xs font-medium",
            isR18ThreadTagName(tag.name)
              ? "bg-destructive/80 text-destructive-foreground"
              : "bg-primary/15 text-primary",
          )}
        >
          {tag.name}
        </li>
      ))}
    </ul>
  );
};
